module.exports = __webpack_public_path__ + "img/slider_galery_11.999e141b.jpg";